import { postApi } from '../../../utils/api'

export function login(data) {
  return postApi({ data, endpoint: 'rest-auth/login/' })
}

export function sendCodePhone(data) {
  return postApi({ data, endpoint: 'api/system/validate-phone/' })
}

export function verifyCodePhone(data) {
  return postApi({ data, endpoint: 'api/system/validate-phone/confirm/' })
}
